// extracted by mini-css-extract-plugin
module.exports = {"dataVisContainer":"_48b577b","dataVisTitle":"_59e1e50","dataVisTitleIcon":"_c3990d8"};